import { Loader, Title } from "@mantine/core";
import { nameToInitials } from "../../../helpers/string.helpers";
import classes from "./styles.module.css";
import { forwardRef } from "react";
import clsx from "clsx";

interface UserBadgeProps {
  firstName?: string;
  lastName?: string;
  online?: boolean;
  white?: boolean;
  small?: boolean;
}
const UserBadge = forwardRef<HTMLDivElement, UserBadgeProps>((props, ref) => {
  return (
    <div
      ref={ref}
      className={classes.container}
      data-white={props.white}
      data-small={props.small}
    >
      {props.firstName || props.lastName ? (
        <>
          <Title
            order={6}
            tt="uppercase"
            c="dark.9"
            className={clsx(["notranslate", classes.title])}
          >
            {nameToInitials(`${props.firstName} ${props.lastName}`)}
          </Title>
        </>
      ) : (
        <Loader />
      )}
      <div
        className={clsx({
          [classes.dot]: !props.small,
          [classes.online]: props.online,
        })}
      />
    </div>
  );
});

export default UserBadge;
